import LinkBtn from '../../../../components/CompUtils/LinkBtn';
import React, { useContext, useState } from 'react';
import { Table } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import { ComiteContext } from '.';
import { rolComiteLegalesSelector, verCVComite } from '../gestionConcursoSlice';
import NuevoMiembroComite from '../NuevoMiembroComite';
import { ROLES_COMITE_ID } from '../../../../const';
import { AlertaDialog } from '../../../../components/CompUtils/Alerta';

const MiembrosComite = (props) => {
  const [showNuevo, setShowNuevo] = useState(false);
  const [rolNuevo, setRolNuevo] = useState({});
  const roles = useSelector(rolComiteLegalesSelector);
  const { comite, setComite } = useContext(ComiteContext);
  const [alert, setAlert] = useState(false);
  const [textAlert, setTextAlert] = useState('');

  function esMiembroCargado(miembro) {
    var retorno = false;
    for (const [key, rol] of Object.entries(roles)) {
      if (comite.usuarios[key]) {
        comite.usuarios[key].forEach((element) =>
          element.usuario.idUsuario === miembro.idUsuario ? (retorno = true) : (retorno = false),
        );
      }
    }
    return retorno;
  }

  function representacionAsignada(miembro, idRolComite) {
    if (idRolComite === ROLES_COMITE_ID.VEEDOR && miembro.representacion !== '') {
      return true;
    } else if (idRolComite !== ROLES_COMITE_ID.VEEDOR) {
      return true;
    } else setTextAlert('Debe seleccionar Representación');
    setAlert(true);
    return false;
  }

  const nuevoMiembro = (miembro) => {
    const newRol = comite.usuarios[rolNuevo.idRolComite]
      ? [...comite.usuarios[rolNuevo.idRolComite], { usuario: miembro }]
      : [{ usuario: miembro }];

    if (!esMiembroCargado(miembro)) {
      if (representacionAsignada(miembro, rolNuevo.idRolComite)) {
        setComite({
          ...comite,
          usuarios: {
            ...comite.usuarios,
            [rolNuevo.idRolComite]: newRol,
          },
        });
        setShowNuevo(false);
      } else {
      }
    } else {
      setTextAlert('El usuario ingresado ya está cargado');
      setAlert(true);
    }
  };
  //Evento al hacer click en opción agregar. Abre el dialogo. El guardado en si es en nuevo miembro
  const onAdd = (rol) => {
    setRolNuevo(rol);
    setShowNuevo(true);
  };
  const finalizarConfirmacion = () => {
    setAlert(false);
  };
  const onRemove = (idx, rol) => {
    const idRol = rol.idRolComite;
    const newRol = comite.usuarios[idRol].slice(0); //shallow clone
    newRol.splice(idx, 1);
    setComite({
      ...comite,
      usuarios: {
        ...comite.usuarios,
        [idRol]: newRol,
      },
    });
  };

  return (
    <>
      <hr></hr>
      <h3 className="text-center"> Miembros del Comité</h3>
      <MiembrosComiteTable title="" comite={comite} onAdd={onAdd} onRemove={onRemove} />

      <NuevoMiembroComite
        show={showNuevo}
        title={`Ingresar ${rolNuevo.nombre}`}
        onClose={() => {
          setShowNuevo(false);
        }}
        onNuevoMiembro={(miembro) => nuevoMiembro(miembro)}
        showRepresentacion={rolNuevo.idRolComite === 6 ? true : false}
      />
      <AlertaDialog size="sm" show={alert} onClose={finalizarConfirmacion} closeText="Cerrar">
        <div className="text-center">
          <i
            className="text-warning fa fa-exclamation"
            style={{ fontSize: 64, WebkitTextStroke: '5px white' }}></i>
          <p>{textAlert}</p>
        </div>
      </AlertaDialog>
    </>
  );
};

const useStyles = createUseStyles({
  stripedRow: {
    background: 'rgba(0, 0, 0, 0.05)',
  },
  headerRol: {
    background: '#333',
    verticalAlign: 'middle !important',
    textAlign: 'center',
  },
  rolCell: {
    verticalAlign: 'middle !important',
    textAlign: 'center',
    width: '10%',
    fontWeight: 'bold',
  },
  rolAction: {
    verticalAlign: 'middle !important',
    textAlign: 'center',
    borderBottom: '2px solid darkgray !important',
  },
  rolRow: {
    verticalAlign: 'middle !important',
    textAlign: 'center',
    '& td:first-child': {
      borderBottom: '2px solid darkgray',
    },
  },
  lastRolRow: {
    verticalAlign: 'middle !important',
    borderBottom: '2px solid darkgray !important',
  },
});
const MiembrosComiteTable = ({ comite, onAdd, onRemove, title = '' }) => {
  const roles = useSelector(rolComiteLegalesSelector);
  const classes = useStyles();
  const handleAsignar = (rol) => {
    onAdd(rol);
  };
  const handleRemove = (idx, rol) => {
    onRemove && onRemove(idx, rol);
  };

  const titleRow = title ? (
    <tr>
      <th colSpan="10" className="text-center">
        {title}
      </th>
    </tr>
  ) : (
    ''
  );

  return (
    <Table className={classes.comiteTable} bordered hover size="sm">
      <thead>
        <tr className="text-center">
          <th>Rol</th>
          <th>Designación</th>
          <th>Apellidos</th>
          <th>Nombres</th>
          <th>C.U.I.L.</th>
          <th>Correo</th>
          <th>Teléfono</th>
          <th>CV</th>
          <th colSpan="2">Acciones</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(roles).map((rolId, rolIdx) => {
          const puestos = comite?.usuarios[rolId] || [];
          //Ordeno primero por titular, luego por apellido
          puestos.sort((a, b) => {
            if (a.usuario.titular === b.usuario.titular)
              return a.usuario.apellido > b.usuario.apellido ? 1 : -1;
            else return a.usuario.titular ? -1 : 1;
          });

          return (
            <React.Fragment key={rolIdx}>
              {rolId === '1' && (
                <tr className={`${classes.rolRow} ${rolIdx % 2 === 0 ? classes.stripedRow : ''}`}>
                  <td className={`${classes.headerRol} `} colSpan="10">
                    <strong>
                      <p className="text-light">Comité</p>
                    </strong>
                  </td>
                </tr>
              )}
              {rolId === '5' && (
                <tr className={`${classes.rolRow} ${rolIdx % 2 === 0 ? classes.stripedRow : ''}`}>
                  <td className={`${classes.headerRol} `} colSpan="10">
                    <strong>
                      <p className="text-light">Coordinador Concursal</p>
                    </strong>
                  </td>
                </tr>
              )}
              {rolId === '6' && (
                <tr className={`${classes.rolRow} ${rolIdx % 2 === 0 ? classes.stripedRow : ''}`}>
                  <td className={`${classes.headerRol} `} colSpan="10">
                    <strong>
                      <p className="text-light">Veedores</p>
                    </strong>
                  </td>
                </tr>
              )}
              {/** tengo que mostrar una fila vacia con el rol y la opción de agregar, en caso que no haya miembros */}
              {puestos.length === 0 && (
                <tr className={`${classes.rolRow} ${rolIdx % 2 === 0 ? classes.stripedRow : ''}`}>
                  <td className={classes.rolCell}>{roles[rolId].nombre}</td>
                  <td className={`text-center ${classes.lastRolRow}`} colSpan="7">
                    <i>Sin miembros</i>
                  </td>
                  <td className={classes.rolAction} colSpan="2">
                    <LinkBtn
                      transparent
                      title={`Asignar ${roles[rolId].nombre}`}
                      onClick={() => handleAsignar(roles[rolId])}>
                      <i className="fa fa-lg fa-user-plus text-success"></i>
                    </LinkBtn>
                  </td>
                </tr>
              )}
              {/** si hay miembros, descarto lo de arriba y muestro las filas de miembros; agregar y rol con rowSpan */}
              {puestos.map((pue, idx) => (
                <tr
                  key={idx}
                  className={`${classes.rolRow} ${rolIdx % 2 === 0 ? classes.stripedRow : ''}`}>
                  {idx === 0 && (
                    <td className={classes.rolCell} rowSpan={puestos.length}>
                      {roles[rolId].nombre}
                    </td>
                  )}
                  <MiembroRow
                    className={idx === puestos.length - 1 ? classes.lastRolRow : ''}
                    designacion={!pue.usuario.titular ? 'Alterno' : 'Titular'}
                    miembro={pue.usuario}
                  />
                  <td className={idx === puestos.length - 1 ? classes.lastRolRow : ''}>
                    <LinkBtn
                      transparent
                      title="Desasignar miembro del comité"
                      onClick={() => handleRemove(idx, roles[rolId])}>
                      <i className="fa fa-lg fa-trash text-danger"></i>
                    </LinkBtn>
                  </td>
                  {idx === 0 && (
                    <td className={classes.rolAction} rowSpan={puestos.length}>
                      <LinkBtn
                        transparent
                        title={`Asignar ${roles[rolId].nombre}`}
                        onClick={() => handleAsignar(roles[rolId])}>
                        <i className="fa fa-lg fa-user-plus text-success"></i>
                      </LinkBtn>
                    </td>
                  )}
                </tr>
              ))}
            </React.Fragment>
          );
        })}
      </tbody>
    </Table>
  );
};

const MiembroRow = ({ designacion, miembro, className = '' }) => {
  const dispatch = useDispatch();
  const handleViewCV = () => {
    dispatch(
      verCVComite({
        idUsuario: miembro.idUsuario,
        nombre: miembro.nombre,
        apellido: miembro.apellido,
        cuil: miembro.cuil,
      }),
    );
  };
  const CVBtn = (
    <LinkBtn onClick={handleViewCV} size="sm" transparent>
      <i className="fa fa-file-pdf-o"></i>
    </LinkBtn>
  );
  const miembroRow = !miembro.cuil ? (
    <td colSpan="5" className="text-center">
      <span style={{ float: 'left' }}>
        <i>Sin asignar</i>
      </span>
      <LinkBtn transparent>Asignar miembro</LinkBtn>
    </td>
  ) : (
    <>
      <td className={className}>{miembro.apellido}</td>
      <td className={className}>{miembro.nombre}</td>
      <td className={className}>{miembro.cuil}</td>
      <td className={className}>{miembro.email}</td>
      <td className={className}>{miembro.telefono}</td>
      <td className={className}>{miembro.cv ? CVBtn : <i>Sin CV</i>}</td>
    </>
  );
  return (
    <>
      <td className={className}>
        <div>{designacion}</div>
        {miembro.representacion !== '' && (
          <div>
            <small className="text-muted">{miembro.representacion}</small>
          </div>
        )}
      </td>
      {miembroRow}
    </>
  );
};

export default MiembrosComite;
